module.exports = __webpack_public_path__ + "img/fontSizePlus.5d815cdf.svg";